import { configureStore } from '@reduxjs/toolkit';
import { modalStatusReducer } from 'shared/common/slices';

import { IApplicationContext } from 'shared/common/types/applicationContext';
import { IPreloadedState } from 'shared/common/types/redux';
import { cianCardReducer, editStatusReducer, regionsSliceReducer } from 'shared/createCard/slices';

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReduxStore(context: IApplicationContext, preloadedState: IPreloadedState, debugEnabled: boolean) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer: {
      regions: regionsSliceReducer,
      editStatus: editStatusReducer,
      cianCard: cianCardReducer,
      modalAuthState: modalStatusReducer,
    },
  });
}
